import { render, staticRenderFns } from "./BaseQuantitySelector.vue?vue&type=template&id=dcf28428&functional=true&"
import script from "./BaseQuantitySelector.vue?vue&type=script&lang=ts&"
export * from "./BaseQuantitySelector.vue?vue&type=script&lang=ts&"
import style0 from "./BaseQuantitySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports